import React from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChecklistIcon from "@mui/icons-material/Checklist";
import RemoveIcon from "@mui/icons-material/Remove";
import ConsumersIcon from "@mui/icons-material/Group";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import UserIcon from "@mui/icons-material/Person3";
import BillIcon from "@mui/icons-material/ReceiptLong";
import DatasetIcon from "@mui/icons-material/Dataset";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import PaidIcon from "@mui/icons-material/Paid";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import ReportsIcon from "@mui/icons-material/Description";
import ArticleIcon from "@mui/icons-material/Article";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import FeedIcon from "@mui/icons-material/Feed";
import CampaignIcon from "@mui/icons-material/Campaign";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

import {
  adminDashboardRoute,
  backupPowerRoute,
  changeOfCategoryRoute,
  // dashboardRoute,
  demandExtensionRoute,
  demandReductionRoute,
  myRequestRoute,
  nameTransferRoute,
  netMeteringRoute,
  permanentRoute,
  premiseAmalgamationRoute,
  premiseRemovalRoute,
  removalOfConnectionRoute,
  shiftingOfServiceRoute,
  temporaryRoute,
  adminPowerApplicationRequestsRoute,
  adminUtilityConsumerRoute,
  adminMasterDataRoute,
  consumerComplaintRoute,
  adminComplaintRoute,
  consumerDashboardRoute,
  adminBillingCycleRoute,
  adminMeterReadingRoute,
  adminBillCalculationsDataRoute,
  consumerPaymentHistoryRoute,
  consumerBillsRoute,
  adminPaymentHistoryRoute,
  consumerUtilityConsumersRoute,
  adminReportsRoute,
  adminBillingCalculationReportRoute,
  adminUnpaidBillsRoute,
  adminUserDocumentsRoute,
  adminTechnicalSanctionDocumentsRoute,
  adminDemandEstimateDocumentsRoute,
  adminSecurityDepositRoute,
  adminBillingBackupPowerRoute,
  adminHomePageContentRoute,
  adminHomePageDocumentRoute,
  adminTemporaryDisconnectedConsumerRoute,
  adminDispatchedBillRoute,
  otherUtilitiesPermanentRoute,
  otherUtilitiesTemporaryRoute,
  myOtherRequestRoute,
  adminOtherApplicationRequestsRoute,
  adminPowerAbstractRoute,
  userManagement,
  approverManagement,
  adminOutstandingReportRoute,
  adminOfflinePaymentRoute,
  adminPowerMissingReadingsRoute,
  adminPowerOutstandingNoticeRoute,
  adminOutstandingInvoiceRoute,
  adminBillingUserBillsRoute,
  otherUtilitiesNameChangeRoute,
  otherUtilitiesDemandReductionRoute,
  otherUtilitiesDemandExtensionRoute,
  fireSafetyConsumerDashboardRoute,
  otherUtilitiesRemovalOfConnectionRoute,
  adminOtherBillingMeterReadingRoute,
  adminBillingDailyMeterReadingsReportRoute,
  fireSafetyCalenderRoute,
  fireSafetyUserManagementRoute,
  fireSafetyAdminDashboardRoute,
  fireRegisterBuildingRoute,
  fireSafetyMyRequestRoute,
  fireSafetyAdminBuildingApplicationsRoute,
  adminPaymentDebitNoteRoute,
  fireSafetyAdminReportsRoute,
  adminOtherBillingCalculationReportRoute,
  fireSafetyAdminBuildingObservationRoute,
  consumerDebitNoteRoute,
  adminAuthorizedUsers,
  adminOtherBillingInvoiceReportRoute,
  adminDcsAdditionalRoute,
  adminOtherMonthlyBillingReport,
  adminPaymentCreditNoteRoute,
  consumerCreditNoteRoute,
  utilityTunnelUserManagementRoute,
  utilityTunnelAccessApplicationRoute,
  utilityTunnelAdminDashboardRoute,
  utilityTunnelConsumerDashboardRoute,
  utilityTunnelMyRequestApplicationRoute,
  cgrfGiftPclRoute,
  fireMockDrillRoute,
  fireNocRoute,
} from "Routes/constants";
import {
  CONSUMER,
  DCS_CONSUMER_BILLING_INCHARGE,
  DCS_CONSUMER_BILLING_OPERATOR,
  FIRE_EMERGENCY_CHIEF_FIRE_OFFICER,
  FIRE_SAFETY_CONSUMER,
  FIRE_SAFETY_SUPER_ADMIN,
  POWER_BACKUP_POWER_BILLING_FINANCE,
  POWER_BANKING_FINANCE,
  POWER_CGRF_ADMIN,
  POWER_CONSUMER_BILLING_INCHARGE,
  POWER_CONSUMER_BILLING_OPERATOR,
  POWER_READ_ADMIN,
  SUPER_ADMIN,
  UTA_CARD_ISSUANCE_SUPER_ADMIN,
  UTILITY_TUNNEL_CONTRACTOR,
  UTILITY_TUNNEL_EMPLOYEE,
  allAdminRoles,
  dcsApplicationsRoles,
  fireSafetyAdminRoles,
  fireSafetyRoles,
  otherUtilitiesCreditnoteAdminRoles,
  otherUtilitiesFinanceAdminRoles,
  powerAdmin2Roles,
  powerApplicationsRoles,
  sewageApplicationsRoles,
  solidWasteApplicationsRoles,
  utilityTunnelAdminRoles,
  waterApplicationsRoles,
} from "common/constant";

const otherUtilitiesAllowedRoles = [
  ...dcsApplicationsRoles,
  ...waterApplicationsRoles,
  ...sewageApplicationsRoles,
  ...solidWasteApplicationsRoles,
];

const sidebarList = [
  {
    name: "Dashboard",
    url: adminDashboardRoute,
    icon: <DashboardIcon />,
    isParent: true,
    allowRoles: allAdminRoles,
  },
  // {
  //   name: "Dashboard",
  //   url: dashboardRoute,
  //   icon: <DashboardIcon />,
  //   isParent: true,
  //   allowRoles: [CONSUMER],
  // },

  {
    name: "Applications",
    url: "",
    allowRoles: [
      ...powerApplicationsRoles,
      ...dcsApplicationsRoles,
      ...waterApplicationsRoles,
      ...sewageApplicationsRoles,
      ...solidWasteApplicationsRoles,
    ],
    icon: <ChecklistIcon className="fs-4" />,
    children: [
      {
        name: "Power Applications",
        url: adminPowerApplicationRequestsRoute,
        allowRoles: powerApplicationsRoles,
        icon: <RemoveIcon />,
        parentName: "Applications",
        level: 1,
      },
      {
        name: "DCS, Water, Sewage, Solid Waste",
        url: adminOtherApplicationRequestsRoute,
        icon: <RemoveIcon />,
        isParent: true,
        allowRoles: [
          ...dcsApplicationsRoles,
          ...waterApplicationsRoles,
          ...sewageApplicationsRoles,
          ...solidWasteApplicationsRoles,
        ],
        parentName: "Applications",
        level: 1,
      },
    ],
    isParent: true,
  },

  {
    name: "Utility Consumers",
    url: adminUtilityConsumerRoute,
    icon: <ConsumersIcon />,
    isParent: true,
    allowRoles: allAdminRoles,
  },
  {
    name: "Users",
    url: "",
    allowRoles: [SUPER_ADMIN],
    icon: <UserIcon className="fs-4" />,
    children: [
      {
        name: "User Management",
        url: userManagement,
        allowRoles: [SUPER_ADMIN],
        icon: <RemoveIcon />,
        parentName: "Users",
        level: 1,
      },
      {
        name: "Approver Management",
        url: approverManagement,
        icon: <RemoveIcon />,
        parentName: "Users",
        level: 1,
        allowRoles: [SUPER_ADMIN],
      },
      {
        name: "Utility Consumer Access",
        url: adminAuthorizedUsers,
        icon: <RemoveIcon />,
        parentName: "Users",
        level: 1,
        allowRoles: [SUPER_ADMIN],
      },
    ],
    isParent: true,
  },
  {
    name: "Master Data",
    url: adminMasterDataRoute,
    icon: <DatasetIcon />,
    isParent: true,
    allowRoles: [SUPER_ADMIN],
  },

  {
    name: "Billing",
    url: "",
    icon: <BillIcon className="fs-4" />,
    allowRoles: allAdminRoles,
    isParent: true,
    typeName: "billing",
    children: [
      {
        name: "Billing Cycle",
        url: adminBillingCycleRoute,
        icon: <RemoveIcon />,
        allowRoles: allAdminRoles,
        parentName: "Billing",
        level: 1,
      },
      {
        name: "Consumer Bills",
        url: adminBillCalculationsDataRoute,
        allowRoles: allAdminRoles,
        icon: <RemoveIcon />,
        parentName: "Billing",
        level: 1,
      },
      {
        name: "Unpaid Bills",
        allowRoles: allAdminRoles,
        url: adminUnpaidBillsRoute,
        icon: <RemoveIcon />,
        parentName: "Billing",
        level: 1,
      },
      {
        name: "Dispatched Bills",
        url: adminDispatchedBillRoute,
        allowRoles: allAdminRoles,
        icon: <RemoveIcon />,
        parentName: "Billing",
        level: 1,
      },
      {
        name: "Missing Readings",
        url: adminPowerMissingReadingsRoute,
        allowRoles: allAdminRoles,
        icon: <RemoveIcon />,
        parentName: "Billing",
        level: 1,
      },
      {
        name: "User Bills",
        url: adminBillingUserBillsRoute,
        allowRoles: allAdminRoles,
        icon: <RemoveIcon />,
        parentName: "Billing",
        level: 1,
      },
      {
        name: "Outstanding Notice",
        url: adminPowerOutstandingNoticeRoute,
        allowRoles: allAdminRoles,
        icon: <RemoveIcon />,
        parentName: "Billing",
        level: 1,
      },
      {
        name: "Power",
        allowRoles: powerApplicationsRoles,
        icon: <RemoveIcon />,
        typeName: "power-billing",
        parentName: "Billing",
        level: 1,
        children: [
          {
            name: "Meter Readings",
            url: adminMeterReadingRoute,
            allowRoles: powerApplicationsRoles,
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Billing Calculation",
            allowRoles: powerApplicationsRoles,
            url: adminBillingCalculationReportRoute,
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Security Deposit",
            url: adminSecurityDepositRoute,
            icon: <RemoveIcon />,
            allowRoles: powerApplicationsRoles,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Backup Power",
            url: adminBillingBackupPowerRoute,
            icon: <RemoveIcon />,
            allowRoles: powerApplicationsRoles,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Power Abstract",
            url: adminPowerAbstractRoute,
            allowRoles: powerApplicationsRoles,
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Daily Meter Readings",
            url: adminBillingDailyMeterReadingsReportRoute,
            icon: <RemoveIcon />,
            allowRoles: powerApplicationsRoles,
            parentName: "Power",
            level: 2,
          },
        ],
      },
      {
        name: "DCS, Water, Sewage, Solid Waste",
        icon: <RemoveIcon />,
        allowRoles: otherUtilitiesAllowedRoles,
        parentName: "Billing",
        typeName: "other-utility-billing",
        level: 1,
        children: [
          {
            name: "Meter Readings",
            url: adminOtherBillingMeterReadingRoute,
            allowRoles: otherUtilitiesAllowedRoles,
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
          },
          {
            name: "Billing Calculation (SAP Upload Document)",
            allowRoles: otherUtilitiesAllowedRoles,
            url: adminOtherBillingCalculationReportRoute,
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
          },
          {
            name: "E-Invoice Report",
            allowRoles: otherUtilitiesFinanceAdminRoles,
            url: adminOtherBillingInvoiceReportRoute,
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
          },
          {
            name: "DCS Bill Data Annexure",
            url: adminDcsAdditionalRoute,
            allowRoles: dcsApplicationsRoles,
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
          },
          {
            name: "Monthly Billing Report",
            url: adminOtherMonthlyBillingReport,
            allowRoles: otherUtilitiesAllowedRoles,
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
          },
        ],
      },
    ],
  },

  {
    name: "Disconnected Consumers",
    url: adminTemporaryDisconnectedConsumerRoute,
    icon: <PersonOffIcon className="fs-4" />,
    isParent: true,
    allowRoles: powerApplicationsRoles,
  },
  {
    name: "Complaints",
    url: adminComplaintRoute,
    icon: <AnnouncementIcon />,
    isParent: true,
    allowRoles: [...powerApplicationsRoles, ...otherUtilitiesAllowedRoles],
  },
  {
    name: "Reports",
    url: adminReportsRoute,
    icon: <ReportsIcon />,
    isParent: true,
    allowRoles: [...powerApplicationsRoles, ...dcsApplicationsRoles],
  },
  {
    name: "Dashboard",
    url: consumerDashboardRoute,
    icon: <DashboardIcon className="fs-4" />,
    isParent: true,
    allowRoles: [CONSUMER],
  },

  {
    name: "My Request",
    url: "",
    icon: <ChecklistIcon className="fs-4" />,
    allowRoles: [CONSUMER],
    isParent: true,
    typeName: "my-request",
    children: [
      {
        name: "Power Applications",
        url: myRequestRoute,
        allowRoles: [CONSUMER],
        icon: <RemoveIcon />,
        parentName: "My Request",
        level: 1,
      },
      {
        name: "DCS, Water, Sewage, Solid Waste",
        url: myOtherRequestRoute,
        icon: <RemoveIcon />,
        allowRoles: [CONSUMER],
        parentName: "My Request",
        level: 1,
      },
    ],
  },

  {
    name: "Applications",
    url: "",
    icon: <ListAltIcon className="fs-4" />,
    allowRoles: [CONSUMER],
    isParent: true,
    typeName: "application-form",
    children: [
      {
        name: "Power",
        allowRoles: [CONSUMER],
        icon: <RemoveIcon />,
        typeName: "power-application-form",
        parentName: "Applications",
        level: 1,
        children: [
          {
            name: "Permanent Connection",
            url: permanentRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Temporary Connection",
            url: temporaryRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Name Change/Transfer",
            allowRoles: [CONSUMER],
            url: nameTransferRoute,
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Demand Alteration",
            allowRoles: [CONSUMER],
            url: "",
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
            children: [
              {
                name: "Demand Reduction",
                url: demandReductionRoute,
                allowRoles: [CONSUMER],
                icon: <RemoveIcon />,
                parentName: "Demand Alteration",
                level: 3,
              },
              {
                name: "Demand Extension",
                url: demandExtensionRoute,
                allowRoles: [CONSUMER],
                icon: <RemoveIcon />,
                parentName: "Demand Alteration",
                level: 3,
              },
            ],
          },
          {
            name: "Premise Amalgamation",
            url: premiseAmalgamationRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Premise Removal",
            url: premiseRemovalRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Shifting of Service",
            url: shiftingOfServiceRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Change of Category",
            allowRoles: [CONSUMER],
            url: changeOfCategoryRoute,
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Net Metering",
            url: netMeteringRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Backup Power",
            url: backupPowerRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
          {
            name: "Removal of Connection",
            url: removalOfConnectionRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "Power",
            level: 2,
          },
        ],
      },
      {
        name: "DCS, Water, Sewage, Solid Waste",
        icon: <RemoveIcon />,
        allowRoles: [CONSUMER],
        parentName: "Applications",
        typeName: "other-application-form",
        level: 1,
        children: [
          {
            name: "Permanent Connection",
            url: otherUtilitiesPermanentRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
          },
          {
            name: "Temporary Connection",
            url: otherUtilitiesTemporaryRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
          },
          {
            name: "Name Change/Transfer",
            url: otherUtilitiesNameChangeRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
          },
          {
            name: "Demand Alteration",
            allowRoles: [CONSUMER],
            url: "",
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
            children: [
              {
                name: "Demand Reduction",
                url: otherUtilitiesDemandReductionRoute,
                allowRoles: [CONSUMER],
                icon: <RemoveIcon />,
                parentName: "Demand Alteration",

                level: 3,
              },
              {
                name: "Demand Extension",
                url: otherUtilitiesDemandExtensionRoute,
                allowRoles: [CONSUMER],
                icon: <RemoveIcon />,
                parentName: "Demand Alteration",
                level: 3,
              },
            ],
          },
          {
            name: "Removal Of Connection",
            url: otherUtilitiesRemovalOfConnectionRoute,
            allowRoles: [CONSUMER],
            icon: <RemoveIcon />,
            parentName: "DCS, Water, Sewage, Solid Waste",
            level: 2,
          },
        ],
      },
    ],
  },
  {
    name: "My Complaints",
    url: consumerComplaintRoute,
    icon: <AnnouncementIcon />,
    isParent: true,
    allowRoles: [CONSUMER],
  },
  {
    name: "My Bills",
    url: consumerBillsRoute,
    icon: <ReceiptLongIcon />,
    isParent: true,
    allowRoles: [CONSUMER],
  },
  {
    name: "My Debit Note Advice",
    url: consumerDebitNoteRoute,
    icon: <FactCheckIcon />,
    isParent: true,
    allowRoles: [CONSUMER],
  },
  {
    name: "My Credit Note Advice",
    url: consumerCreditNoteRoute,
    icon: <CreditScoreIcon />,
    isParent: true,
    allowRoles: [CONSUMER],
  },
  {
    name: "Payment",
    url: "",
    icon: <ListAltIcon className="fs-4" />,
    children: [
      {
        name: "Payment History",
        url: adminPaymentHistoryRoute,
        icon: <RemoveIcon />,
        allowRoles: allAdminRoles,
        parentName: "Payment",
        level: 1,
      },
      {
        name: "Outstanding Report",
        url: adminOutstandingReportRoute,
        allowRoles: [
          ...powerApplicationsRoles,
          DCS_CONSUMER_BILLING_INCHARGE,
          DCS_CONSUMER_BILLING_OPERATOR,
        ],
        icon: <RemoveIcon />,
        parentName: "Payment",
        level: 1,
      },
      {
        name: "Outstanding Invoice",
        url: adminOutstandingInvoiceRoute,
        allowRoles: [
          ...powerAdmin2Roles,
          SUPER_ADMIN,
          POWER_BACKUP_POWER_BILLING_FINANCE,
          POWER_BANKING_FINANCE,
          POWER_READ_ADMIN,
          DCS_CONSUMER_BILLING_INCHARGE,
        ],
        icon: <RemoveIcon />,
        parentName: "Payment",
        level: 1,
      },
      {
        name: "Offline Payment",
        url: adminOfflinePaymentRoute,
        level: 1,
        parentName: "Payment",
        icon: <RemoveIcon />,
        allowRoles: allAdminRoles.filter((item) => item !== POWER_READ_ADMIN),
      },
      {
        name: "Debit Note Advice",
        url: adminPaymentDebitNoteRoute,
        level: 1,
        parentName: "Payment",
        icon: <RemoveIcon />,
        allowRoles: [
          POWER_CONSUMER_BILLING_INCHARGE,
          POWER_CONSUMER_BILLING_OPERATOR,
          SUPER_ADMIN,
        ],
      },
      {
        name: "Credit Note Advice",
        url: adminPaymentCreditNoteRoute,
        level: 1,
        parentName: "Payment",
        icon: <RemoveIcon />,
        allowRoles: otherUtilitiesCreditnoteAdminRoles,
      },
    ],
    isParent: true,
    allowRoles: allAdminRoles,
  },

  {
    name: "Payment History",
    url: consumerPaymentHistoryRoute,
    icon: <PaidIcon />,
    isParent: true,
    allowRoles: [CONSUMER],
  },

  {
    name: "Utility Consumers",
    url: consumerUtilityConsumersRoute,
    icon: <ConsumersIcon />,
    isParent: true,
    allowRoles: [CONSUMER],
  },
  {
    name: "Documents",
    url: "",
    icon: <ArticleIcon className="fs-4" />,
    children: [
      {
        name: "User Documents",
        url: adminUserDocumentsRoute,
        allowRoles: allAdminRoles,
        icon: <RemoveIcon />,
        parentName: "Documents",
        level: 1,
      },
      {
        name: "Technical Sanction",
        url: adminTechnicalSanctionDocumentsRoute,
        allowRoles: allAdminRoles,
        icon: <RemoveIcon />,
        parentName: "Documents",
        level: 1,
      },
      {
        name: "Demand Estimate",
        url: adminDemandEstimateDocumentsRoute,
        icon: <RemoveIcon />,
        allowRoles: allAdminRoles,
        parentName: "Documents",
        level: 1,
      },
    ],
    isParent: true,
    allowRoles: powerApplicationsRoles,
  },
  {
    name: "Home Page Content",
    url: "",
    icon: <NewspaperIcon className="fs-4" />,
    children: [
      {
        name: "Documents",
        url: adminHomePageDocumentRoute,
        icon: <RemoveIcon />,
        allowRoles: [SUPER_ADMIN],
        parentName: "Home Page Content",
        level: 1,
      },
      {
        name: "Information Pages",
        url: adminHomePageContentRoute,
        icon: <RemoveIcon />,
        allowRoles: [SUPER_ADMIN],
        parentName: "Home Page Content",
        level: 1,
      },
    ],
    isParent: true,
    allowRoles: [SUPER_ADMIN],
  },
  {
    name: "CGRF - GIFTPCL",
    url: cgrfGiftPclRoute,
    icon: <FeedIcon />,
    isParent: true,
    allowRoles: [SUPER_ADMIN, CONSUMER, POWER_READ_ADMIN, POWER_CGRF_ADMIN],
  },

  // Fire safety
  {
    name: "Dashboard",
    url: fireSafetyConsumerDashboardRoute,
    icon: <DashboardIcon className="fs-4" />,
    isParent: true,
    allowRoles: [FIRE_SAFETY_CONSUMER],
  },

  {
    name: "Dashboard",
    url: fireSafetyAdminDashboardRoute,
    icon: <DashboardIcon className="fs-4" />,
    isParent: true,
    allowRoles: fireSafetyAdminRoles,
  },

  {
    name: "Building Information",
    url: fireSafetyAdminBuildingApplicationsRoute,
    icon: <ChecklistIcon className="fs-4" />,
    isParent: true,
    allowRoles: fireSafetyAdminRoles,
  },
  {
    name: "Building Observation",
    url: fireSafetyAdminBuildingObservationRoute,
    icon: <AssuredWorkloadIcon className="fs-4" />,
    isParent: true,
    allowRoles: fireSafetyAdminRoles,
  },

  {
    name: "My Request",
    url: "",
    icon: <ChecklistIcon className="fs-4" />,
    allowRoles: [FIRE_SAFETY_CONSUMER],
    isParent: true,
    typeName: "my-request",
    children: [
      {
        name: "Building Information",
        url: fireSafetyMyRequestRoute,
        allowRoles: [FIRE_SAFETY_CONSUMER],
        icon: <RemoveIcon />,
        parentName: "My Request",
        level: 1,
      },
    ],
  },
  {
    name: "Calendar",
    url: fireSafetyCalenderRoute,
    icon: <CalendarMonthIcon className="fs-4" />,
    isParent: true,
    allowRoles: [FIRE_EMERGENCY_CHIEF_FIRE_OFFICER, FIRE_SAFETY_SUPER_ADMIN],
  },
  {
    name: "User Management",
    url: fireSafetyUserManagementRoute,
    icon: <UserIcon className="fs-4" />,
    isParent: true,
    allowRoles: [FIRE_SAFETY_SUPER_ADMIN],
  },
  {
    name: "Reports",
    url: fireSafetyAdminReportsRoute,
    icon: <ReportsIcon className="fs-4" />,
    isParent: true,
    allowRoles: fireSafetyAdminRoles,
  },
  {
    name: "Register Building",
    url: fireRegisterBuildingRoute,
    icon: <LocalFireDepartmentIcon />,
    isParent: true,
    allowRoles: [FIRE_SAFETY_CONSUMER],
  },
  {
    name: "Mock Drill",
    url: fireMockDrillRoute,
    icon: <CampaignIcon />,
    isParent: true,
    allowRoles: fireSafetyRoles,
  },
  {
    name: "Fire NOC",
    url: fireNocRoute,
    icon: <VerifiedUserIcon />,
    isParent: true,
    allowRoles: fireSafetyRoles,
  },

  {
    name: "My Request",
    url: "",
    allowRoles: [UTILITY_TUNNEL_EMPLOYEE, UTILITY_TUNNEL_CONTRACTOR],
    icon: <ChecklistIcon className="fs-4" />,
    isParent: true,
    children: [
      {
        name: "Applications",
        url: utilityTunnelMyRequestApplicationRoute,
        allowRoles: [UTILITY_TUNNEL_EMPLOYEE, UTILITY_TUNNEL_CONTRACTOR],
        icon: <RemoveIcon />,
        parentName: "My Request",
        level: 1,
      },
    ],
  },
  {
    name: "Applications",
    url: utilityTunnelMyRequestApplicationRoute,
    icon: <ChecklistIcon />,
    isParent: true,
    allowRoles: utilityTunnelAdminRoles,
  },
  {
    name: "New Application",
    url: utilityTunnelAccessApplicationRoute,
    allowRoles: [UTILITY_TUNNEL_EMPLOYEE, UTILITY_TUNNEL_CONTRACTOR],
    icon: <ArticleIcon className="fs-4" />,
    isParent: true,
  },
  {
    name: "Users",
    url: "",
    allowRoles: [UTA_CARD_ISSUANCE_SUPER_ADMIN],
    icon: <UserIcon className="fs-4" />,
    children: [
      {
        name: "User Management",
        url: utilityTunnelUserManagementRoute,
        allowRoles: [UTA_CARD_ISSUANCE_SUPER_ADMIN],
        icon: <RemoveIcon />,
        parentName: "Users",
        level: 1,
      },
    ],
  },
];

export const getSidebarList = (roles) =>
  sidebarList
    .filter(
      ({ allowRoles }) => !!roles.find((role) => allowRoles.includes(role))
    )
    .map((menuItem) => {
      const obj = { ...menuItem };
      if (menuItem.children?.length) {
        obj.children = obj.children
          .filter(({ allowRoles }) =>
            roles.some((role) => allowRoles.includes(role))
          )
          .map((menuItem) => {
            const obj = { ...menuItem };
            if (menuItem.children?.length) {
              obj.children = obj.children.filter(({ allowRoles }) =>
                roles.some((role) => allowRoles.includes(role))
              );
            }
            return obj;
          });
      }
      return obj;
    });
